import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Alert, Button, Form, Input, Modal, notification, Radio, Select} from "antd"
import queryString from "query-string"
import {createBatchByNumberV3, listLevels, listPartner} from "../../../services/api/3dApi"

const {Option} = Select

BatchRecycle.propTypes = {
    selectedBatchId: PropTypes.array,
    getBatchesError: PropTypes.func.isRequired,
    onResetSelected: PropTypes.func.isRequired
}

function BatchRecycle(props) {
    const {selectedBatchId, items, getBatchesError, onResetSelected} = props
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [isOpen, setIsOpen] = useState(false)
    const [validate, setValidate] = useState('')
    const [user, setUser] = useState('')
    const [level, setLevel] = useState('1')
    const [levels, setLevels] = useState([])
    const [partner, setPartner] = useState('')
    const [partners, setPartners] = useState([])
    const [errLevels, setErrLevels] = useState('')
    const [errPartner, setErrPartner] = useState('')

    let listItemSelected = []

    items.map(item => {
        if (selectedBatchId.includes(item._id)) {
            return listItemSelected.push(item.item)
        } else {
            return null
        }
    })

    function _showModal() {
        setLoading(false)
        setIsOpen(true)
        setError('')
        setValidate('')
    }

    function _closeModal() {
        setLoading(false)
        setIsOpen(false)
        setError('')
        setValidate('')
    }

    function _handleChangeInput(e) {
        const {value} = e.target

        setUser(value)
    }

    function _handleChange(e) {
        const {value} = e.target

        setLevel(value)
    }

    function _handleChangePartner(value) {
        setPartner(value)
    }

    async function _onRecycleBatch() {
        setLoading(true)
        setError('')

        try {
            if (user === undefined || user === '') {
                setLoading(false)
                setValidate('Vui lòng nhập vào người tái tạo lô.')

                return
            }

            const params = {
                templates: listItemSelected.map(item => item.marketplace + '_' + item.item_number),
                user_create: user,
                level: level,
                partner: partner
            }

            const {data: response} = await createBatchByNumberV3(params)

            const {success, error, data} = response

            if (!success) {
                setLoading(false)
                setError(error)

                return
            }

            setLoading(false)
            _closeModal()

            if (data.batch._id) {
                const win = window.open(`/batches/${data.batch._id}`, "_blank")
                win.focus()
            }

            if (!!data.errorMessages && data.errorMessages.length > 0) {
                notification.error({
                    message: 'Lỗi',
                    description: data.errorMessages.map((item, index) => {
                        return <p className='mb-0' key={index}>{item}</p>
                    })
                })
            }

            onResetSelected()
            getBatchesError()
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    async function _fetchLevels() {
        try {
            const {data: response} = await listLevels()

            const {success, error, data} = response

            if (!success) {
                setLevels(error)

                return
            }

            setErrLevels('')
            setLevels(data)
        } catch (e) {
            setErrLevels(e.message)
        }
    }

    async function _fetchPartners() {
        try {
            const payload = {type: 'print_partner'}
            const query = queryString.stringify(payload)

            const {data: response} = await listPartner(query)

            const {success, error, data} = response

            if (!success) {
                setErrPartner(error)

                return
            }

            setErrPartner('')
            setPartners(data.partners)
        } catch (e) {
            setErrPartner(e.message)
        }
    }

    useEffect(() => {
        if (isOpen) {
            _fetchLevels()
            _fetchPartners()
        }
    }, [isOpen])

    return (
        <div className="BatchRecycle">
            <Button loading={loading}
                    onClick={_showModal}
            >
                Tái tạo lô
            </Button>
            <Modal
                visible={isOpen}
                title="Tái tạo lô"
                onOk={_onRecycleBatch}
                onCancel={_closeModal}
                footer={[
                    <Button key="back" onClick={_closeModal}>
                        Hủy
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={_onRecycleBatch}>
                        Tái tạo
                    </Button>
                ]}
            >
                {error && <Alert message={error} type='error' className='mb-3'/>}

                <Form.Item
                    label='Tên người tái tạo lô'
                    validateStatus={validate && 'error'}
                    help={validate}
                >
                    <Input value={user} onChange={_handleChangeInput}/>
                </Form.Item>

                <Form.Item
                    label='Chọn đối tác'
                    validateStatus={errPartner && 'error'}
                    help={errPartner}
                >
                    <Select onChange={_handleChangePartner} defaultValue={partner}>
                        <Option value=''>---Hãy chọn một đối tác---</Option>
                        {
                            partners.length > 0 && partners.map(item => {
                                return <Option key={item._id} value={item._id}>{item.name}</Option>
                            })
                        }
                    </Select>
                </Form.Item>

                <Form.Item
                    label='Độ ưu tiên của lô'
                    validateStatus={errLevels && 'error'}
                    help={errLevels}
                >
                    <Radio.Group onChange={_handleChange} defaultValue={level}>
                        {
                            levels.length > 0 && levels.map(item => {
                                return <Radio key={item.key} value={item.key}>{item.value}</Radio>
                            })
                        }
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    label='Danh sách item được tái tạo'
                >
                    <div className="ListItemSelected">
                        {
                            !!listItemSelected && listItemSelected.length > 0 && listItemSelected.map(item => (
                                <span key={item._id}>{`#${item.marketplace}_${item.item_number}`}</span>
                            ))
                        }
                    </div>

                    <span className='float-right'>Đã chọn: <strong>{listItemSelected.length || 0}</strong> items</span>
                </Form.Item>
            </Modal>
        </div>
    )
}

export default BatchRecycle
